<template>
  <div>
    <PageHeader :title="title" :items="itemsPageHeader" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-sm-8"></div>
              <div class="col-sm-4">
                <div class="text-sm-right">
                  <button
                    @click="
                      $router.push({
                        name: 'product-sale-price-promotions_detail',
                        params: { id: 'edit' },
                      })
                    "
                    type="button"
                    class="btn btn-warning waves-effect waves-light"
                  >
                    Edit Sale Price Promotion
                  </button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-row form-group">
                  <label class="col-md-4 col-form-label">Promotion</label>
                  <div class="col-md-8">
                    <input
                      v-model="filter.promotion"
                      type="text"
                      placeholder="รหัส Promotion / ชื่อ Promotion"
                      class="form-control"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-row form-group">
                  <label class="col-md-4 col-form-label">สินค้า</label>
                  <div class="col-md-8">
                    <input
                      v-model="filter.product"
                      type="text"
                      placeholder="รหัสกลุ่มสินค้า / รหัสสินค้า / ชื่อสินค้า"
                      class="form-control"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-8">
                <div class="form-row form-group">
                  <label class="col-md-3 col-form-label"
                    >วันที่ Promotion</label
                  >
                  <div class="col-md-4">
                    <input
                      v-model="filter.promotion_start_date"
                      type="datetime-local"
                      class="form-control"
                    />
                  </div>
                  <label class="col-md-1 col-form-label text-center">ถึง</label>
                  <div class="col-md-4">
                    <input
                      v-model="filter.promotion_end_date"
                      type="datetime-local"
                      class="form-control"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="form-row form-group">
                  <label class="col-md-2 col-form-label">สถานะ Promotion</label>
                  <div class="col-form-label row" style="margin-left: 0px">
                    <b-form-checkbox
                      @change="onSelectAllStatus($event)"
                      class="custom-checkbox-info mb-3"
                      style="margin-right: 10px"
                      name="allStatus"
                      id="allStatus"
                      v-model="selectAllStatus"
                      >เลือกทั้งหมด</b-form-checkbox
                    >
                    <div
                      v-for="(data_status, index) in optionAllStatus"
                      :key="index"
                    >
                      <b-form-checkbox
                        v-model="filter.status"
                        :value="data_status"
                        class="custom-checkbox-info mb-3"
                        style="margin-right: 10px"
                        :name="data_status.toLowerCase()"
                        :id="data_status.toLowerCase()"
                        >{{ data_status }}
                      </b-form-checkbox>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12 text-sm-right">
                <div class="button-items">
                  <button
                    type="button"
                    class="btn btn-primary waves-effect"
                    @click="onFilter()"
                  >
                    <i class="bx bx-search font-size-16 align-middle mr-2"></i>
                    Search
                  </button>
                  <button
                    type="button"
                    class="btn btn-light waves-effect"
                    @click="onClear()"
                  >
                    <i class="bx bx-reset font-size-16 align-middle mr-2"></i>
                    Clear
                  </button>
                  <!-- <b-dropdown text="Export" variant="secondary">
                    <template slot="button-content"
                      >Export<i class="mdi mdi-chevron-down"></i
                    ></template>
                    <b-dropdown-item @click="onExportExcel()"
                      >Excel
                    </b-dropdown-item>
                  </b-dropdown> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card" v-if="showDataTable">
          <div class="card-body">
            <div class="row form-group">
              <div class="col-sm-12 col-md-9">
                <div id="tickets-table_length" class="dataTables_length">
                  <span>จำนวน</span>
                  <label class="d-inline-flex align-items-center">
                    <b-form-select
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                      @change="onFilter()"
                      class="ml-3"
                    ></b-form-select>
                  </label>
                  <span class="ml-2"
                    >รายการ จากทั้งหมด {{ totalRecords | number }} รายการ</span
                  >
                </div>
              </div>
              <div class="col-sm-12 col-md-3">
                <div class="input-group md-form form-sm text-md-right">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <span class="bx bx-search-alt"></span>
                    </span>
                  </div>
                  <input
                    v-model="search"
                    class="form-control my-0 py-1"
                    type="search"
                    placeholder="ค้นหา"
                    aria-label="Search"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="table-responsive">
                  <b-table
                    class="table table-centered table-nowrap"
                    ref="productSalePricePromotionTable"
                    :empty-text="'ไม่พบข้อมูล'"
                    :show-empty="
                      items === null ||
                        items === undefined ||
                        (items && items.length === 0)
                    "
                    :bordered="true"
                    :filter="search"
                    :items="items"
                    align="center"
                    v-bind:fields="fields"
                    @filtered="onFiltered"
                    :perPage="perPage"
                  >
                    <template v-slot:cell(index)="data">
                      <div class="text-right">
                        {{ (firstRowOnPage + data.index) | number }}
                      </div>
                    </template>
                    <template v-slot:cell(inventory_status)="data">
                      <span
                        class="label"
                        :class="'label-' + data.value.toLowerCase()"
                        v-html="data.value"
                      ></span>
                    </template>
                    <template v-slot:cell(sale_status)="data">
                      <span
                        class="label"
                        :class="'label-' + data.value.toLowerCase()"
                        v-html="data.value"
                      ></span>
                    </template>
                    <template v-slot:cell(promotion_status)="data">
                      <span
                        class="label"
                        :class="'label-' + data.value.toLowerCase()"
                        v-html="data.value"
                      ></span>
                    </template>
                    <template v-slot:cell(is_vat)="data">
                      <span
                        class="label"
                        :class="'label-' + data.value.toString().toLowerCase()"
                        v-html="data.value"
                      ></span>
                    </template>
                    <template v-slot:cell(promotion_id)="row">
                      <div class="text-right">
                        {{ row.item.promotion_id }}
                        <a
                          @click="onToggleDetails(row)"
                          class="btn btn-ico text-info"
                          ><i
                            :class="
                              row.detailsShowing
                                ? 'bx bx-caret-up'
                                : 'bx bx-caret-down'
                            "
                            title="More Detail"
                          ></i
                        ></a>
                      </div>
                    </template>
                    <template #row-details="row">
                      <div class="card">
                        <div class="card-body">
                          <div class="form-row form-group">
                            <div class="col-sm-2">
                              <div class="table-responsive">
                                <b-table
                                  class="table table-centered table-nowrap"
                                  ref="absorbownertable"
                                  :empty-text="'ไม่พบข้อมูล'"
                                  :show-empty="
                                    !row.item.absorb_owners ||
                                      row.item.absorb_owners.length == 0
                                  "
                                  :bordered="true"
                                  :items="row.item.absorb_owners"
                                  align="center"
                                  v-bind:fields="fieldsAbsorb"
                                >
                                  <template v-slot:cell(index)="data">
                                    <div class="text-right">
                                      {{ (data.index + 1) | number }}
                                    </div>
                                  </template>
                                </b-table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </b-table>
                </div>
              </div>
            </div>
            <div class="row" v-if="items.length > 0">
              <div class="col-lg-4">
                <div style="position: relative; top: 7px">
                  รายการที่ {{ firstRowOnPage | number }} -
                  {{ lastRowOnPage | number }} จากทั้งหมด
                  {{ totalRecords | number }} รายการ
                </div>
              </div>
              <div class="col-lg-8">
                <b-pagination
                  :total-rows="totalRecords"
                  :per-page="perPage"
                  v-model="pageNo"
                  @change="onClickPagination($event)"
                  class="pagination pagination-rounded justify-content-end mb-2"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </div>
</template>

<script>
import { FormatQty } from '@/helpers/utils/format-qty.js'
import { FormatDate, FormatDateTime } from '@/helpers/utils/format-date.js'
import productSalePricePromotionService from '@/helpers/service/product-sale-price-promotion-service'

import PageHeader from '@/components/page-header'
import appConfig from '@/app.config'
import { eventBus } from '@/main.js'
import {
  productSalePricePromotionComputed,
  productSalePricePromotionMethods,
} from '@/state/helpers'
import { StatusEnum } from '@/enum/status.enum.js'
import moment from 'moment'

export default {
  name: 'product-sale-price-promotion',
  page: {
    title: 'Product Pricing : Sale Price Promotion',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    PageHeader,
  },
  data() {
    return {
      search: null,
      title: 'Product Pricing : Sale Price Promotion',
      itemsPageHeader: [
        {
          text: 'Home',
          href: '/',
        },
        {
          text: 'Product Pricing : Sale Price Promotion',
          active: true,
        },
      ],
      fields: [
        {
          key: 'index',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'ลำดับ',
          thStyle: 'width:80px',
          sortable: true,
        },
        {
          key: 'promotion_id',
          label: 'รหัส Promotion',
          sortable: true,
        },
        {
          key: 'promotion_display_name.th',
          label: 'ชื่อ Promotion',
          sortable: true,
        },
        {
          key: 'promotion_start_date',
          label: 'วันและเวลาเริ่มต้น',
          formatter: (value, key, item) => {
            return FormatDateTime(value)
          },
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'promotion_end_date',
          label: 'วันและเวลาสิ้นสุด',
          formatter: (value, key, item) => {
            return FormatDateTime(value)
          },
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'promotion_status',
          label: 'สถานะโปรโมชั่น',
          thStyle: 'width:120px',
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'product_id',
          label: 'รหัสกลุ่มสินค้า',
          sortable: true,
        },
        {
          key: 'sku_code_ofm',
          label: 'รหัสสินค้า (OFM)',
          sortable: true,
        },
        {
          key: 'product_display_name.th',
          label: 'ชื่อสินค้า',
          sortable: true,
        },
        {
          key: 'inventory_status',
          label: 'สถานะสินค้า',
          thStyle: 'width:120px',
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'sale_status',
          label: 'สถานะการขาย',
          thStyle: 'width:120px',
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'is_vat',
          label: 'สินค้าคิดภาษี (Vat)',
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'sale_price_include_vat',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'ราคาขาย (Including Vat)',
          sortable: true,
          tdClass: 'text-right',
        },
        {
          key: 'sale_price_promotion_exclude_vat',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'ราคาขาย Promotion (Excluding Vat)',
          sortable: true,
          tdClass: 'text-right',
        },
        {
          key: 'sale_price_promotion_include_vat',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'ราคาขาย Promotion (Including Vat)',
          sortable: true,
          tdClass: 'text-right',
        },
        {
          key: 'promotion_gp_rate',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'GP Rate Promotion (%)',
          sortable: true,
          tdClass: 'text-right',
        },
        {
          key: 'absorb_type',
          label: 'Absorb Type',
          sortable: true,
        },
      ],
      fieldsAbsorb: [
        {
          key: 'index',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'ลำดับ',
          thStyle: 'width:80px',
          sortable: true,
        },
        {
          key: 'owner',
          label: 'ฝ่ายที่ Absorb',
          sortable: true,
        },
        {
          key: 'absorb_value',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'จำนวนที่ Absorb',
          sortable: true,
          tdClass: 'text-right',
        },
      ],
      listModel: {
        type: Object,
        default: () => {
          return {
            firstRowOnPage: 0,
            items: [],
            lastRowOnPage: 0,
            pageNo: 1,
            totalPages: 0,
            totalRecords: 0,
            pageSize: 10,
            prevPage: 0,
            nextPage: 0,
          }
        },
      },
      items: [],
      pageNo: 1,
      totalPages: 0,
      firstRowOnPage: 0,
      lastRowOnPage: 0,
      totalRecords: 0,
      perPage: 10,
      filter: {
        promotion: '',
        product: '',
        promotion_start_date: moment()
          .startOf('day')
          .format('YYYY-MM-DDTHH:mm'),
        promotion_end_date: moment()
          .endOf('day')
          .format('YYYY-MM-DDTHH:mm'),
        reload: false,
        status: [],
      },
      selectAllStatus: false,
      optionAllStatus: [
        StatusEnum.ACTIVE,
        StatusEnum.COMPLETE,
        StatusEnum.EXPIRE,
        StatusEnum.DELETE,
      ],
      pageOptions: [10, 25, 50, 100],
      showDataTable: false,
    }
  },
  computed: {
    ...productSalePricePromotionComputed,
  },
  mounted() {
    this.filter = Object.assign(
      {},
      this.GET_FILTER_PRODUCT_SALE_PRICE_PROMOTION
    )
    if (this.filter.isFilter) {
      this.onFilter()
    }
  },
  watch: {
    'filter.status': {
      handler() {
        this.selectAllStatus =
          this.filter.status.length === this.optionAllStatus.length
            ? true
            : false
      },
      deep: true,
    },
    GET_FILTER_PRODUCT_SALE_PRICE_PROMOTION(val, oldVal) {
      this.filter = Object.assign({}, val)
    },
    listModel: function(value) {
      this.totalPages = value.totalPages
      this.firstRowOnPage = (value.pageNo - 1) * value.pageSize + 1
      this.lastRowOnPage =
        value.pageSize <= 0
          ? value.totalRecords
          : Math.min(value.pageNo * value.pageSize, value.totalRecords)
      this.totalRecords = value.totalRecords

      if (this.showDataTable) {
        this.$refs.productSalePricePromotionTable.localSortBy = ''
      }
      this.items = value.items
      this.perPage = value.pageSize
      this.pageNo = value.pageNo
    },
  },
  methods: {
    ...productSalePricePromotionMethods,
    onSelectAllStatus(event) {
      this.filter.status = event ? this.optionAllStatus : []
    },
    async onToggleDetails(row) {
      row.toggleDetails()
    },
    async onFiltered(filteredItems) {
      this.totalPages = filteredItems.length
    },
    async onClickPagination(pageNo) {
      this.search = ''
      let params = new URLSearchParams()
      params.append('pageSize', this.perPage)
      params.append('pageNo', pageNo)
      params.append('promotion', this.filter.promotion.trim() || '')
      params.append('product', this.filter.product.trim() || '')
      params.append('promotion_start_date', this.filter.promotion_start_date)
      params.append('promotion_end_date', this.filter.promotion_end_date)
      params.append('sort', 'create_info.timestamp')
      this.filter.status.forEach(element => {
        params.append('status', element)
      })
      let result = await productSalePricePromotionService.getProductSalePricePromotionListAsync(
        params
      )
      if (result.status === 200) {
        this.listModel = result.data
      } else if (
        (result.status && result.status === 404) ||
        (result.response.status && result.response.status === 404)
      ) {
        console.log('error', result.response.data.message)
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification('error', result.response.data.message, 2000)
      }
    },
    async onFilter() {
      this.showDataTable = true
      let params = new URLSearchParams()
      params.append('pageSize', this.perPage)
      params.append('promotion', this.filter.promotion.trim() || '')
      params.append('product', this.filter.product.trim() || '')
      params.append('promotion_start_date', this.filter.promotion_start_date)
      params.append('promotion_end_date', this.filter.promotion_end_date)
      params.append('sort', 'create_info.timestamp')
      this.filter.status.forEach(element => {
        params.append('status', element)
      })
      let result = await productSalePricePromotionService.getProductSalePricePromotionListAsync(
        params
      )
      if (result.status === 200) {
        this.listModel = result.data
      } else if (
        (result.status && result.status === 404) ||
        (result.response.status && result.response.status === 404)
      ) {
        console.log('error', result.response.data.message)
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification('error', result.response.data.message, 2000)
      }
      this.ADD_FILTER_PRODUCT_SALE_PRICE_PROMOTION(this.filter)
    },
    onClear() {
      this.filter.promotion = ''
      this.filter.product = ''
      this.filter.promotion_start_date = moment()
        .startOf('day')
        .format('YYYY-MM-DDTHH:mm')
      this.filter.promotion_end_date = moment()
        .endOf('day')
        .format('YYYY-MM-DDTHH:mm')
      this.filter.status = []
      this.filter.reload = true
    },
  },
}
</script>
<style></style>
